import { logEvent } from "firebase/analytics";
import { analytics } from "./firebase";

const safeLogEvent = (eventName, params = {}) => {
  if (analytics) {
    try {
      logEvent(analytics, eventName, {
        ...params,
        timestamp: new Date().toISOString()
      });
    } catch (error) {
      console.warn('Analytics event logging failed:', error);
    }
  }
};

// Page view tracking
export const trackPageView = (pageName) => {
  safeLogEvent('page_view', { page_name: pageName });
};

// Checkout step tracking
export const trackCheckoutStep = (step, data = {}) => {
  safeLogEvent('checkout_progress', {
    step_name: step,
    ...data
  });
};

// Error tracking
export const trackPaymentError = (errorType, errorMessage, errorContext = {}) => {
  safeLogEvent('payment_error', {
    error_type: errorType,
    error_message: errorMessage,
    ...errorContext
  });
};

// Payment success tracking
export const trackPaymentSuccess = (amount, currency, paymentMethod, metadata = {}) => {
  safeLogEvent('purchase', {
    value: amount,
    currency: currency,
    payment_method: paymentMethod,
    ...metadata
  });
};

// Form interaction tracking
export const trackFormInteraction = (fieldName, interactionType) => {
  safeLogEvent('form_interaction', {
    field_name: fieldName,
    interaction_type: interactionType
  });
};

// Performance tracking
export const trackPerformanceMetric = (metricName, value, context = {}) => {
  safeLogEvent('performance_metric', {
    metric_name: metricName,
    value: value,
    ...context
  });
};

// User behavior tracking
export const trackUserBehavior = (behaviorType, data = {}) => {
  safeLogEvent('user_behavior', {
    behavior_type: behaviorType,
    ...data
  });
};
